//
//
//
//
//
//
//
//
//
//
//
//
//

import './css/index.css'
import upoladFile from "@/components/uploadFile/index"
export default {
  components:{
    upoladFile
  },
  props:['maxlength'],
  data(){
    return{
      images:[],
      // options: {
      //   getThumbBoundsFn (index) {
      //     let thumbnail = document.querySelectorAll('.previewer-demo-img')[index]
      //     let pageYScroll = window.pageYOffset || document.documentElement.scrollTop
      //     let rect = thumbnail.getBoundingClientRect()
      //     return {x: rect.left, y: rect.top + pageYScroll, w: rect.width}
      //   }
      // }
    }
  },
  methods:{
    remove(index){
      this.images.splice(index,1)
    },
    success(file){
      let url = process.env.BASE_API + file.FileUrl
      this.images.push({
        msrc: url,
        src: url
      })
    },
    upfile(){
      this.$refs.upoladFile.chooseFile()
    },
    show (index) {
      this.$refs.previewer.show(index)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/uploadImage/index.vue